module.exports = __webpack_public_path__ + "img/sand-dune-decal-22.c28ab750.png";